import React from "react";

import HerBazaarHeader from "@/mk2/apps/bazaar/containers/HerBazaarHeader/HerBazaarHeader";
import Reviews from "@/mk2/apps/bazaar/containers/Reviews/Reviews";
import { Props } from "@/mk2/apps/bazaar/containers/SellerReviews/SellerReviewsPage";
import {
    bazaarSellerReviewsFromBuyersUrl,
    bazaarSellerReviewsFromSellersUrl,
} from "@/mk2/apps/bazaar/urls";
import { Interpolate } from "@/mk2/components/Interpolate";
import { PROFILE_username_BLOCKED_BY_USER } from "@/mk/autogenerated/translations/SellerReviews.1724d45e4449bfad86548459b7e74b7e";
import { canManageBazaar } from "@/mk/bazaar/common/userUtils";

import styles from "./SellerReviews.mscss";

class SellerReviews extends React.Component<Props> {
    public render() {
        const {
            seller,
            routeNavigate,
            location,
            routePathPattern,
            routeParams,
            requestUserPermissions,
        } = this.props;

        if (
            seller?.hasBlockedBazaar &&
            seller?.user?.isBlockedSelf &&
            !canManageBazaar(requestUserPermissions)
        ) {
            return (
                <div className={styles.SellerReviews}>
                    <div className={styles.SellerReviews__selfBlocked}>
                        <Interpolate
                            i18nKey={PROFILE_username_BLOCKED_BY_USER}
                            username={<strong>{seller.user.username}</strong>}
                        />
                    </div>
                </div>
            );
        }

        return (
            <div className={styles.SellerReviews}>
                {seller && (
                    <HerBazaarHeader
                        seller={seller}
                        routePathPattern={routePathPattern}
                        location={location}
                    />
                )}

                <Reviews
                    fromSellersPath={bazaarSellerReviewsFromSellersUrl}
                    fromBuyersPath={bazaarSellerReviewsFromBuyersUrl}
                    routeNavigate={routeNavigate}
                    location={location}
                    routePathPattern={routePathPattern}
                    routeParams={routeParams}
                />
            </div>
        );
    }
}

export default SellerReviews;
